import { schema as schemas } from 'normalizr'
import qs from 'qs'
import { CallApi } from '@signavio/kraken'

import { TaskFiltersType } from '../../../types'
import { schema as taskSchema } from './task'

export { collection } from './task'

export const schema = new schemas.Array(taskSchema)

export const fetch =
  (callApi: CallApi, apiBase: string) => (query: TaskFiltersType) =>
    callApi(
      `${apiBase}/tasks${qs.stringify(query, {
        arrayFormat: 'brackets',
        addQueryPrefix: true,
      })}`,
      schema
    )
